import { ca } from '@cian/analytics';

export function trackConstructionProgressClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FeaturesJK',
    action: 'Click',
    label: 'BuildingProgress',
    useLastProducts: true,
  });
}
